// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__3AchR","upload":"Small_upload__3E_qv","imageWrap":"Small_imageWrap__2Xw7q","removeBtn":"Small_removeBtn__1WJZb"};